import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';

const useDiscardChanges = () => {
  return useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    modalType: MODAL_TYPE.danger,
    actionPosition: ACTION_POSITIONS.end,
    title: 'Unsaved changes',
    icon: { icon: ICONS.info, iconType: ICON_TYPES.outlined },
    message: `Changes you made will not be saved. Are you sure you want to leave this page?`,
    confirmBtn: { label: 'Leave without saving' },
    cancelBtn: { label: 'Stay on this Page' },
  });
};

export default useDiscardChanges;
